import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

const Education = () => {
  const [ref, inView] = useInView({
    threshold: 0.5,
  });
  return (
    <section className='section h-auto' ref={ref} id='eduacation'>
      <div className='container mx-auto'>
        <h2 className='h2 text-accent'>Education.</h2>
        <div className='flex flex-col lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0 mt-10 obb'>
          <motion.div
            variants={fadeIn('right', 0.5)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1'>
            <h5 className='h5 mb-4 text-accent'>
              2017 - 2018
            </h5>
            <a href='#' className='text-gradient btn-link'> Secondary Education ( 10th )</a>
            <p className='mb-6'>
            Attended secondary school and completed the curriculum with a focus on core subjects.
            </p>
          </motion.div>
          <motion.div
            variants={fadeIn('left', 0.5)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1'>
            <h5 className='h5 mb-4 text-accent'>
              2019 - 2020
            </h5>
            <a href='#' className='text-gradient btn-link'> Higher Secondary Education ( 12th )</a>
            <p className='mb-6'>
            Completed higher secondary education with a focus on arts subjects, including literature, history, and fine arts.
            </p>
          </motion.div>
        </div>
        <div className='flex flex-col lg:flex-row lg:items-center lg:gap-x-20 lg:gap-y-0  obb'>
          <motion.div
            variants={fadeIn('right', 0.5)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1'>
            <h5 className='h5 mb-4 text-accent'>
              2020 - 2023
            </h5>
            <a href='#' className='text-gradient btn-link'> B.A Political Science Honurs ( Degree )</a>
            <p className='mb-6'>
            Earned a Bachelor of Arts degree with Honours in Political Science. Developed strong analytical and critical thinking skills through extensive research and coursework.</p>
          </motion.div>
          <motion.div
            variants={fadeIn('left', 0.5)}
            initial='hidden'
            whileInView={'show'}
            viewport={{ once: false, amount: 0.3 }}
            className='flex-1'>
            <h5 className='h5 mb-4 text-accent'>
              2022 - 2023
            </h5>
            <a href='#' className='text-gradient btn-link'> Full Stack Web Developer ( Diploma )</a>
            <p className='mb-6'>
            Successfully completed a diploma program in Full Stack Web Development, gaining proficiency in front-end technologies such as HTML, CSS, JavaScript, and frameworks like React.js, as well as back-end technologies such as Node.js, Express.js, and databases like MongoDB.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  )
};

export default Education;
